const HTML_PARAGRAPH_BREAK = '<p><br></p>';
const PLAIN_TEXT_BREAK = '\n\n';

export const appendProposedBody = (existing: string, addition: string, isHtml: boolean): string => {
  if (existing === '') {
    return addition;
  }

  return `${existing}${isHtml ? HTML_PARAGRAPH_BREAK : PLAIN_TEXT_BREAK}${addition}`;
};
